import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-24 md:py-32 text-center">
      <p className="font-heading font-extrabold text-7xl md:text-9xl text-primary-100 select-none">
        404
      </p>
      <h1 className="mt-2 font-heading font-bold text-2xl text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
        你访问的页面不存在或已被移动，回到首页继续探索精彩动漫吧。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-100 text-foreground-700 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-search-line"></i>
          搜索动漫
        </Link>
      </div>
    </div>
  );
}